import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const APP_NAME = 'MCH Commission';

const routeTitles: Record<string, string> = {
  '/': 'Dashboard',
  '/dashboard': 'Dashboard',
  '/profile': 'My Profile',
  '/change-password': 'Change Password',
  '/admin/users': 'User Management',
  '/csv-upload': 'Blotter Upload',
  '/blotters': 'Blotters',
  '/transactions': 'Transactions',
  '/accounts': 'Accounts',
  '/clients': 'Clients',
  '/employees': 'Employees',
  '/account-matching': 'Account Matching',
  '/commission-presets': 'Commission Presets',
  '/reports/blotter': 'Blotter Report',
  '/reports/user': 'User Report',
  '/reports/client': 'Client Report',
  '/reports/account': 'Account Report',
  '/login': 'Login',
};

export const useDocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const pageTitle = routeTitles[path];

    document.title = pageTitle
      ? `${pageTitle} | ${APP_NAME}`
      : APP_NAME;
  }, [location.pathname]);
};
